import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Logo } from '../assets/img/logo.svg';

const Footer = () => {
  const { t, i18n } = useTranslation();

  return (
    <Box sx={{
      backgroundColor: '#fff',
      boxShadow: '0px -2px 10px rgba(50, 50, 50, 0.05)',
      padding: 2,
    }}>
      <Container>
        <Grid container
          sx={{
            alignItems: "center",
            flexDirection: { xs: 'column-reverse', sm: 'row' },
            justifyContent: "space-between"
          }}
        >
          <Grid item xs={12} sm={7} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', sm: 'flex-start' } }}>
              <Logo style={{ width: 120 }} />
              <Typography variant="body2" sx={{ mb: 1, mt: -2, maxWidth: 275, textAlign: { xs: 'center', sm: 'left' } }}>
                {t('footer_tagline')}
              </Typography>
              <Typography color='secondary' variant="caption">
                {t('footer_copyright')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={5} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', sm: 'flex-start' } }}>
            <Link to={`/${i18n.language}/create`} style={{ textDecoration: 'none', color: 'inherit', fontSize: '0.90rem', marginBottom: 4 }}>
                {t('create_page_cta')}
              </Link>
              <Link to={`/${i18n.language}/terms`} style={{ textDecoration: 'none', color: 'inherit', fontSize: '0.90rem', marginBottom: 4 }}>
                {t('terms_of_use')}
              </Link>
              <Link to={`/${i18n.language}/privacy`} style={{ textDecoration: 'none', color: 'inherit', fontSize: '0.90rem', marginBottom: 4 }}>
                {t('privacy_policy')}
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
